const Moment = require('moment');

exports.MIN_AGE = 13;
exports.MAX_AGE = 150;

exports.getAge = (birthdate) => {

    if (!birthdate) {
        return null;
    }

    return Moment().diff(birthdate, 'years');
};

exports.buildBirthdateFromAge = (age) => Moment().subtract(age, 'years').toDate();

exports.validateAgeRange = ({
    birthdate,
    minAge = exports.MIN_AGE,
    maxAge = exports.MAX_AGE
}) => {

    if (!birthdate) {
        return null;
    }

    const age = exports.getAge(birthdate);

    if (age < minAge) {
        return `Must be at least ${minAge}`;
    }

    if (age > maxAge) {
        return `Must be at most ${maxAge}`;
    }

    return null;
};
